

































import Vue from 'vue';
import Component from 'vue-class-component';
import DadosVeiculo from '@/components/dados/DadosVeiculo.vue';
import DetalhesPlano from '@/components/detalhes/DetalhesPlano.vue';
import DetalhesProsseguir from '@/components/detalhes/DetalhesProsseguir.vue';
import DetalhesTerceiros from '@/components/detalhes/DetalhesTerceiros.vue';
import { showErroCotacao } from '@/utils/showErroCotacao';
import {
  detalhesPlano,
  detalhesCobertura,
} from '@/components/detalhes/detalhes';

@Component({
  components: {
    DadosVeiculo,
    DetalhesTerceiros,
    DetalhesProsseguir,
    DetalhesPlano,
  },
})
export default class Detalhes extends Vue {
  get detalhesPlano() {
    return detalhesPlano;
  }

  get detalhesCobertura() {
    return detalhesCobertura;
  }

  get loadingCotacao() {
    return this.$store.state.loading_cotacao;
  }

  public async mounted() {
    this.$store.commit('SET_SIDEBAR_SHOWING', true);
    this.$store.commit('SET_SIDEBAR_ENABLED', true);

    const query = (this.$route.query as unknown) as { id?: string };
    if (query.id && `${this.$store.state.cotacao.protocolo}` !== query.id) {
      try {
        await this.$store.direct.dispatch.LOAD_COTACAO(Number(query.id));
      } catch (error) {
        if ((error as any)?.response?.data?.expired) {
          (this as any).$swal({
            icon: 'warning',
            title: 'Simulação expirada',
            text: 'Essa simulação expirou. Por favor, realize uma nova simulação.',
          });
        } else {
          showErroCotacao(this, error);
        }

        const { id, ...remainingQuery } = this.$route.query;
        this.$router.replace({ name: 'dados', query: remainingQuery });
        return;
      }
    }

    window.fbq('track', 'PageView');
    window.funnelytics.functions.step();
  }

  public visibilityChanged(isVisible: boolean) {
    this.$store.commit(
      'SET_SIDEBAR_SHOWING',
      !(this.$vuetify.breakpoint.xsOnly && isVisible)
    );
  }

  get fipeValor() {
    return this.$store.state.cotacao.valor_fipe;
  }
}
